import React from "react";
import BootstrapButton from "react-bootstrap/Button";
import { clsx } from "clsx";
import ButtonProps from "./@types/ButtonProps";
import styles from "./button.module.scss";
import Icon from "../Icon";

const Button = React.forwardRef<HTMLButtonElement, ButtonProps>(
  (props, ref) => {
    const {
      variant,
      disabled,
      children,
      uppercase = true,
      leftIcon,
      leftIconStyle,
      rightIcon,
      rightIconStyle,
      buttonShadow = true,
      className,
      size,
      useUpdatedStyles,
      ...rest
    } = props;

    const buttonClassname = clsx(
      styles.buttonComponent,
      styles[`button-${variant}`],
      size && styles[`button-size-${size}`],
      useUpdatedStyles && styles["use-updated-styles"],
      uppercase && styles.uppercase,
      buttonShadow && styles.buttonShadow,
      className
    );

    return (
      <BootstrapButton
        className={buttonClassname}
        disabled={variant === "disabled" || disabled}
        ref={ref}
        {...rest}
      >
        {leftIcon && (
          <Icon
            name={leftIcon}
            style={{ marginLeft: "0px", marginRight: "4px", ...leftIconStyle }}
          />
        )}
        {children}
        {rightIcon && (
          <Icon
            name={rightIcon}
            style={{ marginLeft: "4px", marginRight: "0", ...rightIconStyle }}
          />
        )}
      </BootstrapButton>
    );
  }
);

export default Button;
